import React from 'react';
import { SORTS, VIEWS } from '../utils/browseUtils';

const ViewIcon = ({ id }) => {
  if (id === 'large') {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    );
  }
  if (id === 'small') {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <rect x="3" y="4" width="4" height="4" rx="0.5" />
        <rect x="3" y="10" width="4" height="4" rx="0.5" />
        <rect x="3" y="16" width="4" height="4" rx="0.5" />
        <path d="M10 6h11M10 12h11M10 18h11" />
      </svg>
    );
  }
  if (id === 'list') {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M8 6h13M8 12h13M8 18h13" />
        <circle cx="4" cy="6" r="1.2" fill="currentColor" stroke="none" />
        <circle cx="4" cy="12" r="1.2" fill="currentColor" stroke="none" />
        <circle cx="4" cy="18" r="1.2" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M4 5h16M4 12h16M4 19h16" />
      <path d="M10 5v14" />
    </svg>
  );
};

const BrowseChrome = ({
  folderId,
  path,
  headerEnd,
  view,
  prefs,
  onNavigateFolder,
  onCreateFolder,
  onCreateDoc,
  onSetPref,
}) => (
  <>
    <nav className="docs-browse__crumbs" aria-label="Folder path">
      <div className="docs-browse__crumbs-path">
        <button
          type="button"
          className={`docs-browse__crumb ${!folderId ? 'docs-browse__crumb--current' : ''}`}
          onClick={() => onNavigateFolder?.(null)}
        >
          Docs
        </button>
        {path.map((f, i) => (
          <React.Fragment key={f.id}>
            <span className="docs-browse__sep">/</span>
            <button
              type="button"
              className={`docs-browse__crumb ${i === path.length - 1 ? 'docs-browse__crumb--current' : ''}`}
              onClick={() => onNavigateFolder?.(f.id)}
            >
              {f.name}
            </button>
          </React.Fragment>
        ))}
      </div>
      {headerEnd && (
        <div className="docs-browse__header-actions">{headerEnd}</div>
      )}
    </nav>

    <div className="docs-browse__toolbar">
      <div className="docs-browse__toolbar-group">
        <button type="button" className="docs-browse__btn" onClick={onCreateFolder}>
          New folder
        </button>
        <button type="button" className="docs-browse__btn docs-browse__btn--primary" onClick={onCreateDoc}>
          New doc
        </button>
      </div>
      <div className="docs-browse__toolbar-group docs-browse__toolbar-group--end">
        <div className="docs-browse__views" role="group" aria-label="View">
          {VIEWS.map((v) => (
            <button
              key={v.id}
              type="button"
              className={`docs-browse__view-btn${view === v.id ? ' is-active' : ''}`}
              title={v.label}
              aria-label={v.label}
              aria-pressed={view === v.id}
              onClick={() => onSetPref({ view: v.id })}
            >
              <ViewIcon id={v.id} />
            </button>
          ))}
        </div>
        <label className="docs-browse__sort">
          <span className="docs-browse__sort-label">Sort</span>
          <select
            value={prefs.sort}
            onChange={(e) => {
              const id = e.target.value;
              onSetPref({
                sort: id,
                dir: id === 'date' || id === 'count' ? 'desc' : 'asc',
              });
            }}
            aria-label="Sort by"
          >
            {SORTS.map((s) => (
              <option key={s.id} value={s.id}>
                {s.label}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="docs-browse__dir"
            title={prefs.dir === 'asc' ? 'Ascending' : 'Descending'}
            aria-label={prefs.dir === 'asc' ? 'Sort ascending' : 'Sort descending'}
            onClick={() => onSetPref({ dir: prefs.dir === 'asc' ? 'desc' : 'asc' })}
          >
            {prefs.dir === 'asc' ? '↑' : '↓'}
          </button>
        </label>
      </div>
    </div>
  </>
);

export default BrowseChrome;
